import { MAIN_TOUR } from "./main-tour";
import type { TourDefinition, TourId } from "./types";

/** Central registry of all tours. Future tours (baptism, reporting, …) register here — no other wiring. */
export const TOURS: Record<TourId, TourDefinition> = {
  main: MAIN_TOUR
};

/** The first-run tour that auto-starts for new users. */
export const MAIN_TOUR_ID: TourId = "main";

export function getTour(tourId: TourId): TourDefinition {
  return TOURS[tourId];
}
